import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "sidebar-top px-3" }
const _hoisted_2 = { class: "widget s20 text-black p-4 rounded-40 shadow-200 mb-6 px-7 pt-7 pb-6" }
const _hoisted_3 = { class: "flex align-items-center gap-4 mb-3" }
const _hoisted_4 = {
  key: 0,
  class: "tag-state success ml-4"
}
const _hoisted_5 = {
  key: 1,
  class: "tag-state ml-4"
}
const _hoisted_6 = { class: "secondary-font text-primary-color mb-4" }
const _hoisted_7 = { class: "secondary-font" }

import { ref, onMounted } from 'vue'
import profilService, { type Souscription } from '@/services/profilService'
import authService from '@/services/authService'
import { formatDateFrench } from '@/utils/formatters'


export default /*@__PURE__*/_defineComponent({
  __name: 'SouscriptionWidget',
  setup(__props) {

const souscription = ref<Souscription | null>(null)
const userPhone = ref('')

onMounted(async () => {
  const user = authService.getCurrentUser()
  if (user) {
    userPhone.value = user.telephone || ''
  }
  try {
    const res = await profilService.getSouscription()
    if (res.data) souscription.value = res.data
  } catch (e) {
    // silencieux - le widget ne s'affichera pas
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("img", {
          src: "/public/icons/icon-souscription.svg",
          class: "size-base icon-neutral",
          alt: ""
        }, null, -1)),
        _cache[1] || (_cache[1] = _createElementVNode("h4", { class: "secondary-font" }, "Souscription", -1)),
        (souscription.value?.actif)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Active"))
          : (_openBlock(), _createElementBlock("span", _hoisted_5, "Inactive"))
      ]),
      _createElementVNode("h6", _hoisted_6, _toDisplayString(souscription.value ? 'Valable jusqu\'au ' + _unref(formatDateFrench)(souscription.value.date_fin) : '-'), 1),
      _createElementVNode("h2", _hoisted_7, _toDisplayString(userPhone.value || '-'), 1)
    ])
  ]))
}
}

})